import topTitle from '@/views/template/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      list: [{
        name: '被保险人信息',
        list: [{
          name: '被保险人姓名'
        }, {
          name: '被保险人生日'
        }, {
          name: '被保险人证件类型'
        }, {
          name: '被保险人证件号码'
        }, {
          name: '手机号码'
        }]
      }],
      list2: [{
        name: '方案名称',
        list: [{
          name: '尊享版',
          isClick: true
        }, {
          name: '基础版'
        }]
      }, {
        name: '保障权益',
        list: [{
          name: '20万',
          isClick: true
        }, {
          name: '30万'
        }]
      }]
    };
  }
};